<oaj-notificaciones-general [iEstatus]="1"></oaj-notificaciones-general>
